module.exports = __webpack_public_path__ + "static/media/main-logo.28c8128c.svg";